import { COLORS, hexToRGB } from '../../../../shared/config/colors/colors';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    padding: 20px;
    border-radius: 20px;
    gap: 12px;
    background: ${COLORS.neutral_00};
    border: 1px solid ${COLORS.neutral_20};
    align-items: center;
`;

export const Avatar = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    flex-shrink: 0;
    background: ${COLORS.neutral_05};
    border: 0.5px solid ${hexToRGB(COLORS.black, 0.08)};
`;

export const Info = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
